import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, CircularProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Task } from '../../types/task.type';

interface DeleteTaskDialogProps {
  open: boolean;
  task: Task | null;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteTaskDialog({
  open,
  task,
  loading,
  onClose,
  onConfirm,
}: DeleteTaskDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ fontWeight: 700 }}>{t('tasks.deleteTask')}</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', mt: 0.5 }}>
          {t('tasks.deleteConfirm', { title: task?.title ?? '' })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose} disabled={loading} sx={{ color: 'text.secondary' }}>
          {t('common.cancel')}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={14} color="inherit" /> : undefined}
        >
          {t('tasks.deleteTask')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
